export const TRADE_SETTLEMENT_BLOTTER_PREFIX = 'dealer/trade-settlement';

export const TRADE_SETTLEMENT_BLOTTER_PORTAL_ID = 'TradeSettlementBlotterPortal';
export const TRADE_SETTLEMENT_POSITIONS_BLOTTER_PORTAL_ID = 'TradeSettlementPositionsBlotterPortal';

export const CUSTOMER_POSITION_MONITORING_BLOTTER_PREFIX = 'CustomerPositionMonitoringBlotter';
export const POSITION_MONITORING_BLOTTER_BUTTONS_PORTAL_ID = 'PositionMonitoringBlotterButtonsPortal';
